<template>
    <div class="page-class"
        :class="{'farmer': userType == 'farmer', 'subdist': userType == 'subdist', 'dist': userType == 'dist', 'sale': userType == 'sale'}">
        <div class="page-wrapper">
            <div class="page-content">
                <div class="p-4">
                    <div class="btn-wrapper"
                            @click="clickOpenWelcome()">
                        <div class="btn-txt">
                            Register Success Welcome
                        </div>
                    </div>
                    <div class="btn-wrapper mt-4"
                            @click="clickOpenSuccess()">
                        <div class="btn-txt">
                            Register Success
                        </div>
                    </div>
                    <div class="btn-wrapper mt-4"
                            @click="clickSuccess()">
                        <div class="btn-txt">
                            Popup Success
                        </div>
                    </div>
                </div>
            </div>

            <div class="page-bg"></div>
            <modal-master :controller="modalController"></modal-master>
        </div>
        
    </div>
</template>
<script>
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
//helper
import Locale from '@/helper/locale/locale.js';
//modal
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import { ModalController } from "@/components/Modal/Controller/ModalController.js";
import { RegisterSuccessModalController } from "@/components/Modal/Controller/RegisterSuccessModalController.js";
import { SuccessModalController } from "@/components/Modal/Controller/SuccessModalController.js";

export default {
    name: 'testui',
    mixins: [AccountMixin],
    components: {
        // NavBar
        ModalMaster
    },
    computed: {
        userType: function () {
            return this.$store.state.userType;
        }
    },
    data: function() {
        return {
            lbl: Locale.getLbl(),
            navbarName: "",
            //modal
            modalController: new ModalController(),
            registerSuccessModal: new RegisterSuccessModalController(),
            successModal: new SuccessModalController(),
        };
    },
    created: function () {
        this.navbarName = this.lbl.contactus.nav_name;
        this.modalController.setRegisterSuccessModal(this.registerSuccessModal);
        this.modalController.setSuccessModal(this.successModal);
    },
    methods: {
        clickBack: function () {
            this.$router.push('/profile');
        },
        clickOpenWelcome: function () {
            this.registerSuccessModal
                    .clearText()
                    .setTitle(this.lbl.register.modal_welcome.title)
                    .setMsg(this.lbl.register.modal_welcome.message)
                    .setPoint(100)
                    .setTag('register-success')
                    .show();

            // this.registerSuccessModal.onClickOk((data) => {
            //     if(data.tag == 'register-success'){
            //         this.$router.push('/home');
            //     }
            // });
        },
        clickOpenSuccess: function () {
            this.registerSuccessModal
                    .clearText()
                    .setTitle(this.lbl.register.modal_register_success.title)
                    .setMsg(this.lbl.register.modal_register_success.message)
                    .setTag('register-success')
                    .show();

            // this.registerSuccessModal.onClickOk((data) => {
            //     if(data.tag == 'register-success'){
            //         this.$router.push('/home');
            //     }
            // });
        },
        clickSuccess: function () {
            this.successModal
                    .clearModal()
                    .setTitle(this.lbl.register.modal_register_success.title)
                    .setMsg(this.lbl.register.modal_register_success.message)
                    .setTag('register-success')
                    .show();

            // this.registerSuccessModal.onClickOk((data) => {
            //     if(data.tag == 'register-success'){
            //         this.$router.push('/home');
            //     }
            // });
        }
    }
}
</script>
<style lang="scss" scoped>
    // @import "./Contact.scss";
</style>
<style lang="scss">
.contact-nav {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
}
</style>
